import Vue        from 'vue'
import Core       from "@/modules/core/service/Core";
import security   from "@/main";
import { getApiBaseUrl } from "@/config";
import vuetify    from "@/plugins/vuetify";
import CDmsViewer from "@/modules/dms/viewer/CDmsViewer.vue";
import { filenameFromHeader } from "@/modules/core/service/private/Filename";

const features = function () {
    const popupWidth   = 820;
    const popupHeight  = 765;
    const screenWidth  = screen.width;
    const screenHeight = screen.availHeight;

    return "menubar=no,toolbar=no,location=no,status=no"
        + ",width="  + popupWidth
        + ",height=" + popupHeight
        + ",left="   + ((screenWidth - popupWidth) / 2)
        + ",top="    + ((screenHeight - popupHeight) / 2)
    ;
}

const finished = function (parameter) {
    Vue.prototype.$bus.$emit(Vue.prototype.$events.refreshdocuments, parameter)
}

const handleResponse = function (response, success, error) {
    if (!response.ok) {
        if (response.status === 401) {
            this.logout();
        } else {
            if (error) {
                response.json().then (msg => {
                    error(msg);
                })
            }
        }

        return Promise.reject();
    }

    return response.blob().then(blob => {
        const filename = filenameFromHeader(response.headers.get("Content-Disposition"));

        const data = new Blob([blob], {type: response.headers.get("Content-Type")});
        success(filename, URL.createObjectURL(data));
    })
}

export default {
    url: {
        site       : "/api/document/site/{0}",
        enums      : "/api/document/enums",
        image      : "/api/document/{0}/pdfimage",
        pages      : "/api/document/{0}/pages",
        document   : "/api/document/download/{0}",
        documentraw: "/api/document/download/{0}/raw",
        stamp      : "/api/incident/document/{0}/stamp",
        incident   : "/api/document/incident/{0}",
        path       : "/api/folder/{0}",
        rename     : "/api/document/{0}/rename",
        info       : "/api/document/{0}/info",
        unitdocs   : "/api/incident/unit/{0}/document?type={1}"
    },

    type: {
        PDF  : "PDF",
        MAIL : "MAIL",
        EXCEL: "EXCEL",
        WORD : "WORD",
        IMAGE: "IMAGE"
    },

    event: {
        document: {
            selected: "dms.document.selected",
            refresh : "dms.document.reloaded"
        }
    },

    info (document) {
        return Core.method.get(this.url.info, document);
    },

    open (document, name) {
        const f = features();
        const handle = window.open("", '_blank', f);
        const cmp = new Vue({...CDmsViewer, vuetify });

        cmp.$nextTick(() => {
            cmp.$mount();
            cmp.setDocument (document, true, () => {
                if (name) {
                    handle.document.title = name;
                }

                handle.document.body.style.margin = "0";
                handle.document.body.appendChild (cmp.$el);
            });
        })

        handle.finished = finished;
    },

    icon (contentType, extension) {
        if (extension === 'eml') {
            return "mdi-email-outline"
        }

        if (extension === 'msg') {
            return "mdi-email-outline"
        }

        switch (contentType) {
            case "application/vnd.ms-outlook":
                return "mdi-email-outline"
            case "application/pdf":
                return "mdi-file-pdf-box-outline";
            case "image/png":
            case "image/jpeg":
            case "image/jpg":
            case "image/gif":
                return "mdi-image-outline";

        }

        return "";
    },

    document (documentId) {
        return this.url.document.replace("{0}", documentId);
    },

    download (documentId,  success, error) {
        fetch(getApiBaseUrl() + this.url.documentraw.replace("{0}", documentId), {
            method : "GET",
            headers: security.jsonHeader(),
        })
            .then(response => {
                return handleResponse (response, success, error);
            })
            .catch(e => {
                console.log("error", e)
                if (error) error (e);
            });
    },

    rename (documentId, name, success, error) {
        return Core.method.put(this.url.rename, {
            name: name
        }, documentId).then(data => success(data)).catch(() => error ());
    },

    load (document, success, error) {
        Core.transfer.load(this.url.document.replace("{0}", document), success, error);
    },

    prepare (component, document, success) {
        if (!document) {
            success (null);
            return;
        }

        this.load (document, (fileURL) => {
            fetch(fileURL).then(r => r.blob()).then(blob => {

                if (blob.type === 'application/pdf') {
                    component.$nextTick(() => {
                        success (this.type.PDF, fileURL + "#view=fitH"); // #zoom=scale");
                    })

                    return;
                }

                if (blob.type === 'application/vnd.ms-excel') {
                    success (this.type.EXCEL, fileURL);
                    return;
                }

                if (blob.type === 'application/json') {
                    blob.text().then(x => {
                        success (this.type.MAIL, JSON.parse(x));
                    });

                    return;
                }

                if (blob.type.startsWith('image/')) {
                    component.$nextTick(()=> {
                        success (this.type.IMAGE, fileURL);
                    })
                }
            }).catch(() => {
                Core.message.warning(component, component.$t("dms.document.notfound"))
            })
        }, () => {
                Core.message.warning(component, component.$t("dms.document.notfound"))
        });
    },

    pages (document) {
        return Core.method.get(this.url.pages, document);
    },

    image (document, page, success, error) {
        Core.transfer.load(this.url.image.replace("{0}", document) + "?page=" + page, success, error);
    },

    incident (incidentId, success) {
        Core.method.get(this.url.incident, incidentId).then((folder) => success (folder));
    },

    site (siteId, success) {
        Core.method.get (this.url.site, siteId).then(data => success (data));
    },

    unitDocuments (unitId, type) {
        return Core.method.get(this.url.unitdocs, unitId, type);
    },

    path (guid, success, error) {
        Core.method.get (this.url.path, guid).then(data => success (data)).catch((e) => error (e));
    },
}